import { FoldIcon } from 'icons';
import React from 'react';
import SvgIcon from 'components/SvgIcon';
import { isObject } from 'utils';
import { ComponentBaseProps } from 'types';

type HeaderWithCloseProps = {
  onClose?: () => void;
  title?: string | React.ReactNode;
  icon?: React.ReactNode;
  customCloseIcon?: React.ReactNode;
  iconStyle?: React.CSSProperties;
} & ComponentBaseProps;

export const HeaderWithClose = ({
  onClose,
  title,
  icon = <FoldIcon />,
  customCloseIcon,
  className = '',
  iconStyle,
}: HeaderWithCloseProps) => {
  return (
    <div
      className={`flex px-4 w-full my-1 justify-between items-center ${className}`}
    >
      {isObject(title) ? title : <h2 className='text-sm'>{title}</h2>}
      {customCloseIcon || (
        <div
          data-testid='CADPage-closeMenu'
          className='flex-center cursor-pointer bg-wfGrey100 p-4 h-6 w-6 rounded-full z-[9999]'
          style={iconStyle}
          onClick={onClose}
        >
          <SvgIcon icon={icon} style={{ width: 14, height: 14 }} />
        </div>
      )}
    </div>
  );
};
